import { CLOSE_MODAL, OPEN_MODAL } from 'constants/actions';

export const openModal = (modalType, options = {}) => ({
  type: OPEN_MODAL,
  payload: {
    modalType,
    options,
  },
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});
